import * as React from "react"
import { Chip } from "@mui/material"

export default function companyColumn() {
    return {
        name: "companyName",
        label: "Company",
        options: {
            filterType: "dropdown",
            setCellHeaderProps: () => ({ style: { textAlign: "left" } }),
            setCellProps: () => ({ style: { textAlign: "left" } }),
            customBodyRender: (value) => {
                if (!value) return "—"
                return (
                    <Chip
                        label={value}
                        size="small"
                        variant="outlined"
                        sx={{ fontWeight: 500 }}
                    />
                )
            }
        }
    }
}
